import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface DebugOperation {
  id: string
  timestamp: Date
  operation: string
  collection: string
  documentId?: string
  data?: unknown
  method:
    | 'get'
    | 'set'
    | 'update'
    | 'delete'
    | 'add'
    | 'list'
    | 'query'
    | 'count'
    | 'runClientQuerySpec'
    | 'countClientQuerySpec'
    | 'runQuery'
}

export const useDebugStore = defineStore('debug', () => {
  const operations = ref<DebugOperation[]>([])
  const isDialogVisible = ref(false)

  const addOperation = (operation: Omit<DebugOperation, 'id' | 'timestamp'>) => {
    const debugOperation: DebugOperation = {
      ...operation,
      id: crypto.randomUUID(),
      timestamp: new Date(),
    }
    operations.value.unshift(debugOperation)
  }

  const clearOperations = () => {
    operations.value = []
  }

  const toggleDialog = () => {
    isDialogVisible.value = !isDialogVisible.value
  }

  const showDialog = () => {
    isDialogVisible.value = true
  }

  const hideDialog = () => {
    isDialogVisible.value = false
  }

  return {
    operations,
    isDialogVisible,
    addOperation,
    clearOperations,
    toggleDialog,
    showDialog,
    hideDialog,
  }
})
